import {Injectable} from "@angular/core";
import {DashboardDataModel, dashboardDataModelFactory} from "./dashboard.model";
import {HttpClient} from "@angular/common/http";
import {map} from "rxjs/operators";

@Injectable()
export class DashboardService {
  getDashboardData(projectId?: string, regionId?: string): Promise<DashboardDataModel> {
    const params = [
      projectId ? `projectId=${projectId}` : "",
      regionId ? `regionId=${regionId}` : "",
    ].filter(it => !!it).join("&");
    return this.http.get(`/api/report/dashboard-report?${params}`)
      .pipe(map(json => dashboardDataModelFactory(json)))
      .toPromise();
  }

  getManagerProjects(): Promise<any> {
    return this.http.get(`/api/report/manager-projects`)
      .toPromise();
  }

  constructor(private http: HttpClient) {}
}
